import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { VersionResponse } from '@h5s/entities';
import { mapResponse } from '@h5s/util-object';
import { map, Observable } from 'rxjs';

@Service()
export class DataAccessSystemService {
  /** Services */
  private readonly http = inject(HttpClient);

  /** System Base API Path */
  private static readonly API_BASE_PATH = '/system';

  /** Status Path */
  //TODO PMSWEB-1758: https://kosmosol.atlassian.net/browse/PMSWEB-1758
  //private static readonly STATUS_PATH = `${DataAccessSystemService.API_BASE_PATH}/status`;

  /** Info Path */
  private static readonly INFO_PATH = `${DataAccessSystemService.API_BASE_PATH}/info`;

  /** Ottiene la versione del backend in esecuzione */
  public getBackendVersion(): Observable<VersionResponse> {
    const url = `${DataAccessSystemService.INFO_PATH}/version`;

    return this.http.get<VersionResponse>(url).pipe(map((result) => mapResponse(VersionResponse, result)));
  }
}
